import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import SpeakerCard from './SpeakerCard';
import { showAllSpeakers, locations, locationBoth, locationLondon, locationSanFrancisco } from './locations';

const Speakers = ({ location, avatarPlaceholder, londonChipColor, sfChipColor }) => {
  const data = useStaticQuery(
    graphql`
      query {
        allPretalxSpeaker(sort: {name: ASC}) {
          edges {
            node {
              id
              name
              path
              twitter
              company
              linkedin
              websiteUrl
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 500, height: 500)
                }
              }
              answers {
                answer
                question {
                  question {
                    en
                  }
                }
              }
              pretalxSubmissions {
                pretalxSubmission {
                  state
                }
              }
            }
          }
        }
      }
    `
  );

  const [speakers, setSpeakers] = useState([]);

  useEffect(() => {
    if (!data) {
      return;
    }

    const allSpeakers = data.allPretalxSpeaker.edges.map(({ node }) => node);
    const chosenLocationQ = 'Which event is this chosen for?';
    allSpeakers.forEach((s) => {
      s.answers.forEach(({ question, answer }) => {
        if (question.question.en === chosenLocationQ && locations.includes(answer)) {
          s.location = answer;
        } else if (question.question.en === 'Mastodon') {
          s.mastodon = answer;
        }
      });
    });

    const filteredSpeakers = allSpeakers.filter((s) => {
      const isConfirmed = s.pretalxSubmissions.reduce(
        (a, b) => a?.pretalxSubmission?.state === 'confirmed' || b?.pretalxSubmission?.state === 'confirmed', false
      );
      if (!isConfirmed) {
        return false;
      }
      if (!location || location === showAllSpeakers || s?.location === locationBoth) {
        return true;
      }
      if (location === locationLondon && s.name === 'Dan Jenkins') {
        return true;
      }
      return s?.location === location;
    });

    setSpeakers(filteredSpeakers);
  }, [data, location]);


  return (
    <>
      <div className='rs-team style2 team-home6-style pt-20 pb-20'>
        <div className='container'>
          <div className='row y-middle'>
            {speakers.map((speaker) => {
              let chipColor;
              if (speaker?.location === locationLondon) {
                chipColor = londonChipColor;
              } else if (speaker?.location === locationSanFrancisco) {
                chipColor = sfChipColor;
              }
              return (
                <SpeakerCard
                  key={speaker?.id}
                  speaker={speaker}
                  placeholder={avatarPlaceholder}
                  showLocationChip={location === showAllSpeakers}
                  chipColor={chipColor}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default Speakers;
